import React from 'react'
import '../App.css'

function Profile(props){
  return(
    <div className={`intro ${props.css}`}>
      <h1>{props.name}
      {props.icon && <img className="icon"
        src={props.icon}
        alt={`${props.title} icon`}/>}
      </h1>
      <h2>Aspect of {props.title}</h2>
      <div className="profile">
        <img className={`portait ${props.side}`}
          src={props.portrait}
          alt={`${props.title} portrait`}/>
        <p className='pronouns'><b>Pronouns: </b>{props.pronouns}</p>
        <p><b>Powers: </b>{props.powers}</p>
        <p className="center">{props.title}: {props.definition}</p>
      </div>
    </div>
  )
}

function AltProfile(props){
  return(
    <div className='alt-profile'>
      <h2 className={props.color}>{props.name}</h2>
      {props.portrait && <img className="portrait grey"
      alt={`${props.name} portrait`}
      src={props.portrait}/>}
      <p className={`center ${props.color}`}>{props.pronouns}</p>
      <p className={`center ${props.color}`}>Aspect of {props.title}</p>
    </div>
  )
}

function Characters() {
  return (
    <div>
       <section className="end">
        <Profile
          css='hyph'
          name='Amethyst'
          title='Hyperphantasia'
          pronouns='they/them'
          powers='has the ability to fade as if they were a dream, to become a purple fog which is extremely cold to the touch and can cause cold damage after long contact periods. Also heightens the visualisation of those around them. Can see and interact with the minds of Hyperphantastic people.'
          definition='the ability to form extremely vivid mental images.'
          icon='hyperphantasia.png'
          side='left'
          portrait='amethyst.png'
        />

        <Profile
          css='tas'
          name='Emerald'
          title='Phantasia'
          pronouns='she/he'
          powers='has a very friendly air, making those who first see him more likely to befriend and trust the aspect, can create sensory illusions of any sense which fade into green dust after a certain amount of time. Can see and interact with the minds of Phantastic people.'
          definition='the ability to form moderately vivid mental images.'
          icon='phantasia.png'
          side='right'
          portrait='emerald.png'
        />

        <Profile
          css='hypo'
          name='Ruby'
          title='Hypophantasia'
          pronouns='any/all'
          powers="can control wisp-like lights which can appear and form as a sort of ghost flame, these flames aren't painful but they are warm, and can become harmful if Ruby is in a bad state, can flicker out of sight, becoming invisible. Can see and interact with the minds of Hypophantastic people."
          definition='the ability to form vague and fleeting mental images.'
          icon='hypophantasia.png'
          side='left'
          portrait='ruby.png'
        />

        <Profile
          name='Onyx'
          title='Aphantasia'
          pronouns='they/it/void'
          powers="can melt into any available shadows, becoming a shadow themselves, Onyx can also control said shadows to perform very simple tasks and turn into simple weapon-like shadows, these tendrils can coompletely shut down visualisation. Can see and interact with the minds of Aphants."
          definition="the inability to form mental images in one's mind."
          icon='aphantasia.png'
          side='right'
          portrait='onyx.png'
        />

        <Profile
          css='syne'
          name='Sapphire'
          title='Synesthesia'
          pronouns='they/he'
          powers="can switch the sensory receptors for people, making them experience different senses along with their usual ones, they can also calm others' senses or increase their sensitivity. Sapphire can become a blue liquid if harmed enough. Can see and interact with the senses of Synethetes."
          definition="the ability to experience one of your senses through another."
          side='left'
          portrait='sapphire.png'
        />

        <div className="intro">
          <h1>Other</h1>
          <div className='alt-profiles'>
            <AltProfile
              name="Ink"
              title="Reality and Creation"
              pronouns="they/it"
              portrait="ink.png"
            />
            <AltProfile
              name="Pink"
              title="Imagination, Creativity and Art"
              pronouns="they/them"
              color="pink"
              portrait="pink.png"
            />
            <AltProfile
              name="Lavender"
              title="Dreams"
              pronouns="they/she/dream"
              color="lav"
              portrait="lavender.png"
            />
          </div>
          <AltProfile
              name="White - The Ancient One"
              title="Transcendence and Purity"
              pronouns="she/her"
          />
        </div>
      </section>
    </div>
  )
}

export default Characters;
